/* global translations */
import React from 'react';
import get from 'lodash/get';
import ImageSvg from '../image/ImageSvg';

const VipBadge = () => {
  const onClick = (e) => {
    e.preventDefault();

    window.location.href = '/vip';
  };

  return (
    <span
      role="presentation"
      onClick={onClick}
      onKeyDown={onClick}
      className="memberName-vip tooltip"
      data-tooltip={get(translations, 'txt: VIP lietotājs', '')}
      data-post="true"
    >
      <span className="btn-static">
        <span className="vcenter">
          <span className="vcenter-inner">
            <ImageSvg
              svg="icon-star-vip"
              iconClass="icon--gold icon--star-vip"
            />
          </span>
        </span>
      </span>
    </span>
  );
};

export default VipBadge;
